import {
  ULTRASOUND_FETCH_ALL,
  ULTRASOUND_FETCH_ALL_SUCCESS,
  ULTRASOUND_FETCH_ALL_FAIL,
  ULTRASOUND_SET_SORT,
  ULTRASOUND_SET_PAGE,
  ULTRASOUND_SET_PAGE_SIZE
} from './constants';

export const fetchUltrasoundScans = () => ({
  type: ULTRASOUND_FETCH_ALL
});
export const fetchUltrasoundScansSuccess = scans => ({
  type: ULTRASOUND_FETCH_ALL_SUCCESS, scans
});
export const fetchUltrasoundScansFail = error => ({
  type: ULTRASOUND_FETCH_ALL_FAIL, error
});
export const setUltrasoundSort = sort => ({
  type: ULTRASOUND_SET_SORT, sort
});
export const setUltrasoundPage = page => ({
  type: ULTRASOUND_SET_PAGE, page
});
export const setUltrasoundPageSize = size => ({
  type: ULTRASOUND_SET_PAGE_SIZE, size
});
